import React from 'react'

import { Background } from '@Components/Background'
import { Chip } from '@Components/Chips/Chip/Chip'
import { Element } from '@Components/Elements/Types'
import { Link } from '@Components/Link'
import { ReferenceContentFragment } from '@Generated/graphql'
import { getLinkFromReference, parseExtraColors } from '@Globals/CMS/FieldHelpers'

import styles from './Elements.module.scss'

export const ElementChip = ({
  appearance,
  disableLinks = false,
  reference,
  text,
}: Extract<Element, { __typename: 'ElementChip' }> & {
  disableLinks?: boolean
}) => {
  const extraColors = parseExtraColors(appearance?.extraColors, ['border'])
  const link = getLinkFromReference(reference)

  const content = (
    <Chip
      className={styles.chip}
      style={{
        backgroundColor: appearance?.backgroundColor || undefined,
        borderColor: extraColors.border || undefined,
        color: appearance?.textColor || undefined,
        fontFamily: `var(--font-${appearance?.font || 'gotham'})`,
      }}
    >
      <Background asset={appearance?.asset as ReferenceContentFragment} />
      {text || link?.text || ''}
    </Chip>
  )

  if (disableLinks || !link?.url) {
    return content
  }

  return (
    <Link
      analytics={{
        dest_page_type: link.type,
        dest_page_type_id: link.id || '',
      }}
      href={link.url}
    >
      {content}
    </Link>
  )
}
